/**
 * Routes list
 * BPM Monitor API Routes
 */
const _prefix = String(process.env.API_PREFIX_BPM_EXECUTOR || '/bpm/v1/executor')
// const _prefix2 = String(process.env.API_PREFIX_BPM_SUPERVISOR || '/bpm/v1/supervisor')

export default {
  monitor: {
    // Список доступных процессов для работы Исполнителя
    index: _prefix + "/processes",

    // Подробная информация (включая данные портов) об одном Процессе для Монитора Исполнителя
    show: _prefix + "/processes/{process_id}",

    // Запуск Исполнителем процесса на исполнение
    beginProcess: _prefix + "/processes/{process_id}/take",

    // + Подробная информация (включая данные портов) об одном Процессе для Монитора Исполнителя
    data: _prefix + "/processes/{process_id}/extra_data",

    // Список выходных портов Процесса для Монитора Исполнителя
    ports: _prefix + "/processes/{process_id}/ports",

    // Форма завершения работы над процессом для Исполнителя
    // GET
    portForm: _prefix + "/processes/{process_id}/ports/{port_id}",

    // Форма завершения работы над процессом для Исполнителя
    // PUT
    pushPort: _prefix + "/processes/{process_id}/ports/{port_id}",

    // Завершение Исполнителем работы над процессом
    // PATCH
    finishProcess: _prefix + "/processes/{process_id}/finish"
  },
  
  //
  // Monitor Filters.
  //
  filter: {
    index: _prefix + "/filters",
    show: _prefix + "/filters/{filter_code}",
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/monitor/api/routes.js